import React, { FC } from 'react';
import { Divider as AntdDivider } from 'antd';
import { DividerProps } from 'antd/lib/divider';
import { DividerStyle } from './Divider.style.tsx';

export const Divider: FC<DividerProps & { dashed?: boolean }> = (props) => {
  if (props.dashed) {
    return <div {...props} style={DividerStyle.dashed} />;
  }
  return <AntdDivider {...props} />;
};

export default Divider;
